export default "__VITE_ASSET__CwcLaOtJ__"